import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingText: {
    id: 'app.containers.AppLoadingState.loadingText',
    defaultMessage: 'Loading…',
  },
});
